import { render } from "./DiscountRouter.vue?vue&type=template&id=e5b2a50c"
import script from "./DiscountRouter.vue?vue&type=script&lang=js"
export * from "./DiscountRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__